module.exports = __webpack_public_path__ + "static/paczki_osobno_silver@2x-184f97535fd00c2a38b811ce1a591fe1.png";